module.exports = __webpack_public_path__ + "static/img/img-ptfw2.142e76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw2.png
// module id = 6gRU
// module chunks = 0